<div
  class="flex column wrapper"
  [class.immersive]="immersiveCanvas | async"
>
  <div
    class="payee-case flex column"
    [class.payee-case--minimal]="immersiveCanvas | async"
  >
    @if ((immersiveCanvas | async) === false) {
      <h1>Ügy</h1>
    }
    <div
      class="flex filters"
      [class.filters--minimal]="immersiveCanvas | async"
    >
      <payee-dropdown
        width="shorter"
        [options]="productTypes"
        [(ngModel)]="product"
        (ngModelChange)="resetWorkflowProcesses()"
      >
        @if ((immersiveCanvas | async) === false) {
          <span payee-label>Termék</span>
        }
      </payee-dropdown>
      <payee-dropdown
        width="shorter"
        [options]="partners"
        [(ngModel)]="partner"
        (ngModelChange)="resetWorkflowProcesses()"
      >
        @if ((immersiveCanvas | async) === false) {
          <span payee-label>Partner</span>
        }
      </payee-dropdown>
      <payee-form-field width="normal">
        @if ((immersiveCanvas | async) === false) {
          <span payee-label>Keresés</span>
        }
        <payee-autocomplete
          placeholder="Állapot / átmenet"
          [options]="nodeSearchOptions"
          [displayWith]="nodeSearchDisplayWith"
          [filterPredicate]="nodeSearchFilterPredicate"
          [(ngModel)]="selectedNodeSearch"
          (ngModelChange)="onNodeSearchSelect($event)"
        ></payee-autocomplete>
      </payee-form-field>
      <button
        payee-icon-button
        (click)="resetWorkflowProcesses()"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <button
        payee-icon-button
        (click)="resetZoom()"
      >
        <mat-icon>search</mat-icon>
      </button>
      <button
        payee-icon-button
        (click)="toggleForceExpand()"
      >
        @if (forceExpand.value === false) {
          <mat-icon>unfold_more</mat-icon>
        }
        @if (forceExpand.value === true) {
          <mat-icon>unfold_less</mat-icon>
        }
        @if (forceExpand.value === undefined) {
          <mat-icon>crop_square</mat-icon>
        }
      </button>
      <button
        title="Info értesítések"
        payee-icon-button
        (click)="toggleInfoNotifications()"
      >
        @if (showInfoNotifications.value) {
          <mat-icon>notifications</mat-icon>
        }
        @if (!showInfoNotifications.value) {
          <mat-icon>notifications_off</mat-icon>
        }
      </button>
      <button
        title="Fog of war"
        payee-icon-button
        (click)="toggleFogOfWar()"
      >
        @if (fogOfWar.value) {
          <mat-icon>visibility_off</mat-icon>
        }
        @if (!fogOfWar.value) {
          <mat-icon>visibility</mat-icon>
        }
      </button>
      <button
        payee-icon-button
        (click)="toggleImmersive()"
      >
        @if ((immersiveCanvas | async) === false) {
          <mat-icon>fullscreen</mat-icon>
        }
        @if (immersiveCanvas | async) {
          <mat-icon>fullscreen_exit</mat-icon>
        }
      </button>
      @if ((immersiveCanvas | async) === false) {
        <payee-info style="--width: auto">
          Ez nem egy tökéletes és teljes szimuláció. A különböző folyamatok hatással lehetnek egymásra. A folyamatok elindítása függhet
          extra validációtól.
        </payee-info>
      }
    </div>
  </div>
  @if (workflowProcess && (immersiveCanvas | async) === false) {
    <h1>{{ workflowProcess.label }}</h1>
  }
  <div
    #reteContainer
    class="rete-container"
  ></div>
</div>
